<template>
    <div id="Infoshipp" class="flex flex-col w-full h-auto px-4 mb-12">
        <!-- Header -->
        <div class="flex w-full h-auto justify-center items-center mb-3">
            <span class="Helvetica text-2xl font-bold text-blue-500 justify-center normal-case">Refund Information</span>
        </div>
            <!-- **********Shipping info*********** -->
                 <div class="flex bg-white w-full space-x-2">
                        <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                            <div class="flex w-full mt-1">
                                <span class="rounded-full h-12 w-12 bg-gray-200">
                                    <i class="material-icons p-3 text-blue-400">person</i>
                                </span>

                                <div class="ml-5 w-full pb-4">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                        Order information
                                    </div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="tab-content">
                                      <div id="latest-tasks-new" class="tab-pane active">
                                          <div class="flex items-center">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Order #</span>
                                                 <div class="text-gray-600">{{ $f.getIdbySplit(item.ObjetDetails.orderId)}}</div>
                                               </div>
                                          </div>
                                           <div v-if="item.ObjetDetails.customer" class="flex items-center mt-5">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Customer </span>
                                                 <div class="text-gray-600"><i class="material-icons tiny">contacts</i> {{ item.ObjetDetails.customer.fullName}}</div>
                                                 <div class="text-gray-600"><i class="material-icons tiny">local_phone</i> {{ item.ObjetDetails.customer.phone}}</div>
                                               </div>
                                          </div>
                                           <div class="flex items-center mt-5">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Seller </span>
                                                 <div class="text-gray-600">{{ item.ObjetDetails.fullName}}</div>
                                               </div>
                                          </div>
                                          <div class="items-center mt-5">
                                            <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                              <span  class="font-medium">Refund</span>
                                               <div class="mt-4 border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                        <label for="totalPrice" class="bg-white text-gray-700 px-1">Refund amount <sup>({{currency}})</sup> <span :class="$colors.required"> *</span></label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                        <input id="totalPrice" autocomplete="false" tabindex="0" type="text"
                                                        v-model="item.ObjetDetails.totalPrice"
                                                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                                    </p>
                                                    </div>
                                              
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                          <!-- ****************************** Order Information *********************************************-->

                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                            </span>

                            <div class="ml-5 w-full">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                     Refund Information
                                </div>

                                <div class="w-full space-y-4">
                                  
                                        <div 
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="status" :style="colorStatus(item.status)" class="bg-white text-gray-700 px-1">Status
                                                        <span :class="$colors.required">*</span>
                                                    </label>
                                                </p>
                                            </div>
                                            <p>
                                             <select  :style="colorStatus(item.status)"  v-model="item.status" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                <option class="bg-white" selected :value="null"> Status </option>
                                                <option class="bg-white text-gray-600" v-for="(value, index) in statusShipp" :key="index" :value="value">
                                                    {{ value }}
                                                </option>
                                            </select>
                                            </p>
                                        </div>
                                         <div   class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                <label for="category" class="bg-white text-gray-700 px-1">Accepted date </label>
                                                </p>
                                            </div>
                                            
                                            <p>
                                                <datetime-v2 type="datetime" v-model="item.acceptedAt" :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')"
                                                     placeholder="Accepted date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                                            </p>
                                        </div>
                                         <div v-if="item.status=='effectue'"  class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                <label for="category" class="bg-white text-gray-700 px-1">Shipping date <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            
                                            <p>
                                                <datetime-v2 type="datetime" v-model="item.date" :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')"
                                                     placeholder="Shipping date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                                            </p>
                                        </div>
                                        <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                            <p>
                                                <label for="customerAddress" class="bg-white text-gray-700 px-1" >Comment order<span :class="$colors.required">*</span></label>
                                            </p>
                                            </div>
                                            <p>
                                            <textarea id="comment" type="text" v-model="item.comment"
                                                class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                            </p>
                                            
                                        </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                    <!--*******************  Product Order ***************************************-->
                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_mall</i>
                            </span>

                            <div class="ml-5 w-full pb-4">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                    Order Products
                                </div>

                                <div class="w-full space-y-4">
                                    <div class="w-full">
                                        <table style="display: inline-table;"
                                            class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                                            <thead class="text-white">
                                                <tr
                                                    class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                    <th class="p-2 justify-center">Products</th>
                                                    <th class="p-2 justify-center">Quantity</th>
                                                    <th class="p-2 justify-center">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody class="flex-1 sm:flex-none" v-for="it in item.ObjetDetails.products" :key="it._id">
                                                <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                                                        <div class="flex space-x-10">
                                                            <div>
                                                                <img alt="..."
                                                                    :src="it.image"
                                                                    class="h-16 w-16 rounded-md mx-auto" />
                                                            </div>
                                                            <div>
                                                                {{ it.productName }}
                                                                <p class="font-light">
                                                                    Price : {{ it.unitPrice }} 
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                        {{ it.quantity }}
                                                    </td>
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                        {{ it.quantity * it.unitPrice }} 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            <!-- **************/Shipping info****************-->
    </div>
</template>
<script>
export default {
    props: {
        config: { required: true, type: Object},
        item:{ default: [] },
        index:{ type: Number },
        currentUser:{ type: Object },
        statusShipp:{ type: Array }, 
        currency:{ type: String },
    },
    data() {
        return {

        }
    },
    async mounted() {
       
    },   
    methods: {
    setSelected(courier) {
        console.log(courier)  
    },
    colorStatus(status) {
            switch (status) {
                 case 'pending':
                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                    break;
                case 'accepted':
                    return "color:rgb(8, 194, 226); border-color: rgb(8, 194, 226);"
                    break;
                case 'effectue':
                    return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
                    break;
                    
                case 'rejected':
                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);"
                    break;
            }
        },
    },
    computed: {
        
    },

}
</script>
<style scoped>
 .seller-select .vs__dropdown-toggle {
    border: none;
}
</style>